import { render, staticRenderFns } from "./HealthcareCandidateProfile.vue?vue&type=template&id=198b289b&scoped=true&"
import script from "./HealthcareCandidateProfile.vue?vue&type=script&lang=js&"
export * from "./HealthcareCandidateProfile.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareCandidateProfile.vue?vue&type=style&index=0&id=198b289b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b289b",
  null
  
)

export default component.exports